import * as React from "react";
import { isEmpty } from "lodash";
import { useFormContext, get } from "react-hook-form";

import { ApiError } from "./api-error";
import { findAllByKey, findAllByKeyValue } from "./error-functions";

export const ErrorSummary = ({ apiErrors }: { apiErrors?: ApiError[] }) => {
    const { formState: { errors } } = useFormContext();

    // Input error messages
    const errorRefs = findAllByKey(errors, "ref");

    const inputErrorKeys: string[] = errorRefs.map(ref => ref.name);

    const clientErrorMessages: string[] = inputErrorKeys.map(ek => {
        const error = get(errors, ek);
        return error.message;
    }).filter(m => m);

    // API Error messages
    const apiErrorMessages: string[] = apiErrors ? apiErrors.map(e => e.message).filter(m => m) : [];

    // All error messages
    const errorMessages = clientErrorMessages.concat(apiErrorMessages);

    const hasErrors = !isEmpty(errorMessages);

    return (
        <>
            {hasErrors &&
                <div className="error-summary" role="alert">
                    <p>Please review the following errors:</p>
                    <ul>
                        {errorMessages.reverse().map((errorMessage) => (
                            <li key={errorMessage}>{errorMessage}</li>
                        ))}
                    </ul>
                </div>
            }
        </>
    );
}